import logo from '../../assets/images/logo/logo.png';

export default function AppLoader() {
    return (
        <div
            role="status"
            aria-live="polite"
            aria-label="Loading your workspace"
            className="fixed inset-0 flex flex-col items-center justify-center bg-gray-50 px-6 text-center font-sans"
        >
            <div aria-hidden="true" className="relative flex h-16 w-16 items-center justify-center">
                <div className="absolute inset-0 rounded-full border-2 border-gray-200" />
                <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-brand-lime border-r-brand-lime motion-safe:animate-spin" />
                <img src={logo} alt="" className="h-9 w-9 object-contain dark:invert" />
            </div>
        </div>
    );
}
